"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  Location: () => Location
});
module.exports = __toCommonJS(unavailable_exports);
var import_nativeError = require("../nativeError");
var import_validation = require("./validation");
var Location = Object.freeze({
  getPermissionStatus: function getPermissionStatus() {
    return "denied";
  },
  requestWhenInUsePermission: function requestWhenInUsePermission() {
    return Promise.resolve("denied");
  },
  requestAlwaysAuthorization: function requestAlwaysAuthorization() {
    return Promise.resolve("denied");
  },
  getCurrentPosition: function getCurrentPosition() {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Location.getCurrentPosition"));
  },
  watchPosition: function watchPosition(_onPosition, _onError) {
    var _options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function() {
    };
  },
  geocodeAddress: function geocodeAddress(_address) {
    return Promise.resolve([]);
  },
  reverseGeocode: function reverseGeocode(_latitude, _longitude) {
    return Promise.resolve([]);
  },
  startMonitoring: function startMonitoring(region) {
    (0, import_validation.assertRegion)(region, "startMonitoring");
    return Promise.resolve();
  },
  stopMonitoring: function stopMonitoring(identifier) {
    (0, import_validation.assertIdentifier)(identifier, "stopMonitoring");
    return Promise.resolve();
  },
  monitoredRegions: function monitoredRegions() {
    return [];
  },
  requestState: function requestState(identifier) {
    (0, import_validation.assertIdentifier)(identifier, "requestState");
    return Promise.resolve("unknown");
  },
  addDidEnterRegionListener: function addDidEnterRegionListener(listener) {
    (0, import_validation.assertRegionListener)(listener, "addDidEnterRegionListener");
    return {
      remove: function remove() {
      }
    };
  },
  addDidExitRegionListener: function addDidExitRegionListener(listener) {
    (0, import_validation.assertRegionListener)(listener, "addDidExitRegionListener");
    return {
      remove: function remove() {
      }
    };
  }
});
//# sourceMappingURL=unavailable.js.map
